<template>
  <div class="pos-rel screen-height photos-docu" style="padding-inline:100px; padding-top: 5px; overflow-x:hidden" v-show="this.$store.state.photo.isMainView" id="simple_photo_checkbox" :class="{ 'bottom_nav_open': this.$store.state.photo.isBottomNav,'photos-main-view': isMainView }">
    <div class="position-relative">
      <a download href="" target="_blank" class="d-none" id="download-photo"></a>
      <div v-if="this.$store.state.photo.filtered <= 0" class="py-2 text-center">
        Keine Fotos vorhanden
      </div>
<!--      <div class="pagination-top py-1" v-if="$store.state.photo.TPage > '1'">-->

<!--        <div class="row">-->
<!--          <div class="col-md-3">-->
<!--            <span class=" font-10" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>-->
<!--            <span class=" font-10" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>-->
<!--          </div>-->
<!--          <div class="col-md-6">-->

<!--            <keep-alive>-->
<!--              <sliding-pagination-->
<!--                :current="$store.state.photo.page"-->
<!--                :total="$store.state.photo.TPage"-->
<!--                @page-change="pageChangeHandler"-->
<!--                :classMap='{-->
<!--                   "componentClass": "pagination-bottom border-top pt-2",-->
<!--                   "list": "pagination justify-content-center pagination-sm",-->
<!--                   "element": "page-item ",-->
<!--                   "elementDisabled": "disabled",-->
<!--                   "elementActive": "active",-->
<!--                   "page": "page-link"  }'/>-->
<!--            </keep-alive>-->
<!--          </div>-->
<!--          <div class="col-md-3"></div>-->
<!--        </div>-->



<!--      </div>-->
      <div class="row mt-2 main-photos-page" id="simple_photo" :class="{ isBottomNav: this.$store.state.photo.isBottomNav }">
<!--        <PhotoModal v-bind:photoIDCollection='photos'></PhotoModal>-->
        <div class="col-xl-2 col-lg-3 col-md-4 pl-0"  v-for="(photo, index) in photos" :key="index">
          <div class="simple-photo" @click="setClickIndex($event, index)"
               v-on:click.shift="selectMultiple($event, index)" :data-index="index">
            <photovirtual :key="'list-' + photo.pdphotoid" :instance-id="'list-' + photo.pdphotoid" :imgdata="photo" :index="index" v-if="photo.phototype === '360'"></photovirtual>
            <photodetail :key="'list-' + photo.pdphotoid" :instance-id="'list-' + photo.pdphotoid" :imgdata="photo" :index="index" v-else></photodetail>
          </div>
        </div>
      </div>


      <div class="row mr-0 shadow-sm border  pl-0 position-sticky bg-white border-top pt-1 text-center pagination"  v-if="$store.state.photo.TPage > '1'" style="bottom: 0">
          <div class="col-md-3 text-left pr-0 pt-1">
            <span class="font13" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>
            <span class="font13" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>
          </div>
          <div class="col-md-6 main-photos-pagination">
            <keep-alive>
              <sliding-pagination
                :current="currentPage"
                :total="totalPages"
                @page-change="pageChangeHandler"
                @click.native="nativeNavClick"
                :classMap='{
                   "componentClass": "pagination-bottom border-top pt-2",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link"  }'>
                <!-- Slot für "Vorherige Seite" -->
                <template v-slot:previousPage>
                  <span class="previews_button" style="width:100%;height:100%;display:block;">«</span>
                </template>

                <!-- Slot für "Nächste Seite" -->
                <template v-slot:nextPage>
                  <span  class="next_button" style="width:100%;height:100%;display:block;">»</span>
                </template>
              </sliding-pagination>
            </keep-alive>
          </div>
          <div class="col-md-3"></div>
      </div>

    </div>
  </div>
</template>

<script>
import Popup from './infoPopup'
import SlidingPagination from 'vue-sliding-pagination'
import photodetail from './subitems/photodetail'
import Photovirtual from './subitems/photovirtual.vue'
// import PhotoModal from '../../projects/PhotoModal'
export default {
  name: 'Main',
  props: ['searchString'],
  data () {
    return {
      plans: [],
      selections: [],
      tags: [],
      startDate: '',
      endDate: '',
      meta: [],
      lastimageindex: 0,
      getImagesUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/getlist'
    }
  },
  async mounted () {
    await this.$store.dispatch("getProjectUsers",this.$route.params.id);
  },
  components: {
    Photovirtual,
    Popup,
    SlidingPagination,
    photodetail
    // PhotoModal
  },
  computed: {
    photos () {
      return this.$store.state.photo.photos
    },
    isMainView() {
     return this.$store.state.photo.isMainView;
    },
    creators () {
      return this.$store.state.creators
    },
    selectedImages: {
      get () {
        return this.$store.state.photo.selectedPhotos
      },
      set (val) {
        this.$store.commit('setSelectedPhotos', val)
      }
    },
    isSelecteAble () {
      return this.$store.state.photo.isBottomNav
    },
    currentPage() {
      return this.$store.state.photo.page
    },
    totalPages() {
      return this.$store.state.photo.TPage
    }
  },
  methods: {

    nativeNavClick(log) {

      if(log.srcElement._prevClass == 'previews_button') {
        let selectedPage = this.currentPage -1
        this.$store.commit('setPage', selectedPage)
        this.$root.$emit('pageChangeHandler', selectedPage)
      }
      if(log.srcElement._prevClass == 'next_button') {
        let selectedPage = this.currentPage +1
        this.$store.commit('setPage', selectedPage)
        this.$root.$emit('pageChangeHandler', selectedPage)
      }

      console.log('logcon in Main.vue', log)
    },
    showModal (photoXXL, photosXXL) {
      // this.getfileImage_xxl(photoXXL)
      // this.ScrollZoom($('#image_container'),4,0.25);
      /** Here the Code from the API Picture in Full Size **/
      // Enable the Modal - View if clicked on Picture
      // $('#imagemodal').modal('show')
      // this.$store.state.photo.currentModalPhoto = photoXXL
      console.log('showModal in Main.vue')
      this.$parent.loadXXL(photoXXL)
    },

    getImageMain () {
      this.photos = this.$store.state.photo.photos
    },
    pageChangeHandler (selectedPage) {
      console.log('pageChangeHandler in Main.vue', selectedPage)
      // this.$store.state.photo.page = selectedPage
      this.$store.commit('setPage', selectedPage)
      this.$root.$emit('pageChangeHandler', selectedPage)
    },

    setClickIndex (event, index) {
      if(!event.shiftKey) {
        this.lastimageindex = index
      }
    },

    // Select MultiPhotos On Click Of Shift + Clicked
    selectMultiple (event, last) {
      let obj = this
      if (this.isSelecteAble) {
        let start = this.lastimageindex
        let index = event.target.getAttribute('data-index')
        index = last
        for (let i = start; i < index; i++) {
          if (obj.selectedImages.findIndex((item) => item.pdphotoid === obj.photos[i].pdphotoid) < 0) {
            obj.selectedImages.push(obj.photos[i])
          }
        }
      }
    }

  }

}
</script>
<style>
.main-photos-pagination .pagination-sm .page-link{
  font-size: .94rem;
  padding-inline: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/Main.vue